import { PortableText } from '@portabletext/react'
import { PORTABLE_COMPONENTS } from '../../../lib/helper/portableTextHelpers'
import { IdealImage } from '../../shared/IdealImage'

export const PRODUCT_DETAILS_CATEGORY_COMPONENTS = {
  times: (times: RichText) => {
    return (
      <div className="flex flex-col items-start justify-start">
        <PortableText value={times} components={PORTABLE_COMPONENTS} />
      </div>
    )
  },
  duration: (duration: RichText) => {
    console.log(duration)
    return (
      <div className="flex flex-col items-start justify-start">
        <PortableText value={duration} components={PORTABLE_COMPONENTS} />
      </div>
    )
  },
  tickets: (tickets: RichText) => {
    return (
      <div className="flex flex-col items-start justify-start">
        <PortableText value={tickets} components={PORTABLE_COMPONENTS} />
      </div>
    )
  },
  languages: (languages: Language[]) => {
    return (
      <div className="flex flex-wrap items-start justify-start gap-2 mb-2">
        {languages.map((language, i) => (
          <div
            key={i}
            className="w-6 h-4 rounded-sm overflow-hidden flex-shrink-0"
            title={language.text}
          >
            <IdealImage
              image={language.image}
              alt={language.text}
              width={24}
              height={16}
            />
          </div>
        ))}
      </div>
    )
  },
  meeting_point: (meeting_point: RichText) => {
    return (
      <div className="flex flex-col items-start justify-start">
        <PortableText value={meeting_point} components={PORTABLE_COMPONENTS} />
      </div>
    )
  },
  cancellation_rebook: (cancellation_rebook: RichText) => {
    return (
      <div className="flex flex-col items-start justify-start">
        <PortableText
          value={cancellation_rebook}
          components={PORTABLE_COMPONENTS}
        />
      </div>
    )
  },
  further_information: (further_information: RichText[]) => {
    return (
      <div className="flex flex-col items-start justify-start">
        <PortableText
          value={further_information.reduce(
            (acc, curr) => acc.concat(curr),
            [],
          )}
          components={PORTABLE_COMPONENTS}
        />
      </div>
    )
  },
  inclusions: (further_information: RichText[]) => {
    return (
      <div className="flex flex-col items-start justify-start">
        <PortableText
          value={further_information.reduce(
            (acc, curr) => acc.concat(curr),
            [],
          )}
          components={PORTABLE_COMPONENTS}
        />
      </div>
    )
  },
}
